import { Controller } from "@hotwired/stimulus";

export const STORAGE_KEY = "reveal:list";

const LIST_PATHS = [
  /^\/admin\/reveal\/?$/,
  /^\/reports\/?$/,
  /^\/reports\/internal\/?$/,
  /^\/providers\/[^/]+\/reports\/?$/
];

export function listLocation(value, origin = window.location.origin) {
  if (typeof value !== "string" || value === "") return null;

  let url;
  try {
    url = new URL(value, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  if (!LIST_PATHS.some((pattern) => pattern.test(url.pathname))) return null;

  url.searchParams.delete("restore");
  return `${url.pathname}${url.search}`;
}

function readStored() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStored(value) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    return;
  }
}

export default class extends Controller {
  static values = { role: { type: String, default: "list" } };

  connect() {
    if (this.roleValue === "back") {
      this.useStored();
      return;
    }
    if (this.restore()) return;

    this.record = this.record.bind(this);
    this.record();
    window.addEventListener("pagehide", this.record);
  }

  disconnect() {
    window.removeEventListener("pagehide", this.record);
  }

  record() {
    const current = listLocation(`${window.location.pathname}${window.location.search}`);
    if (current) writeStored(current);
  }

  restore() {
    const url = new URL(window.location.href);
    if (url.searchParams.get("restore") !== "1") return false;

    url.searchParams.delete("restore");
    const current = `${url.pathname}${url.search}`;
    const stored = listLocation(readStored());
    if (stored && stored !== current) {
      this.navigate(stored);
      return true;
    }

    window.history.replaceState(window.history.state, "", `${current}${url.hash}`);
    return false;
  }

  navigate(location) {
    window.location.replace(location);
  }

  useStored() {
    const stored = listLocation(readStored());
    if (stored) this.element.setAttribute("href", stored);
  }
}
